const getCEP = async (zipCode) => {
	const res = await fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`);
	const data = await res.json();
	return { data };
};

export const viacep = { getCEP };
